import axios from "axios";

const instance = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 30000,
});

instance.interceptors.response.use(
  function (response) {
    return response.data;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default instance;
